/*eslint-disable react/jsx-key */
import { useEffect, useMemo } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { Link } from 'react-router-dom';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { ApproveDenyButtons } from './ApproveDenyButtons';
import { BadgePill } from '../../common/Badge';
import useDate from 'src/Admin/utils/useDate';

const showStatusIcons = (cellValue) => {
  let finalStatusValues = {
    variant: 'info',
    text: 'Pending',
    icon: 'pending',
  };
  if (cellValue?.toLowerCase() === 'approved') {
    finalStatusValues = {
      variant: 'primary',
      text: 'Approved',
      icon: 'approved',
    };
  }
  if (cellValue?.toLowerCase() === 'denied') {
    finalStatusValues = {
      variant: 'danger',
      text: 'Denied',
      icon: 'denied',
    };
  }

  return (
    <div className="">
      <span className="submitted-by-date status">
        <BadgePill
          className={'badge-with-border'}
          variant={finalStatusValues.variant}
          text={finalStatusValues.text}
          prefixIcon={finalStatusValues.icon}
        />
      </span>
    </div>
  );
};

const TableDataCell = ({ cell, selectedTabLocal = null }) => {
  //const [showActionButtons, setShowActionButtons] = useState(false);
  const { formatDate } = useDate();
  {
    console.log('hiiiiiiiiiiiiiiiii', cell, selectedTabLocal);
  }
  return (
    <td
      {...cell.getCellProps()}
      className={
        cell.column.id === 'status' &&
        cell.row.values.status?.toLowerCase() === 'pending approval'
          ? 'submitted-on-cell text-left'
          : 'text-left'
      }
    >
      {cell.column.id === 'firstName' ? (
        cell.row.original.status?.toLowerCase() === 'pending approval' ? (
          <Link
            className="common-link"
            to={
              selectedTabLocal === 'affiliation'
                ? '/admin/approvals/request/details/handle-affiliation-requests'
                : '/admin/approvals/request/details'
            }
            state={{
              data: cell.row.original,
              selectedTabLocal: 'affiliation',
              enrollmentOid: cell.row.original.EnrollmentOID,
            }}
            //to="/admin/approvals/request/details"
            //to=""
            //TODO: add id and state for request
          >
            {cell.value} {cell.row.original.MiddleName}{' '}
            {cell.row.original.LastName}
          </Link>
        ) : (
          <>
            {cell.value} {cell.row.original.MiddleName}{' '}
            {cell.row.original.LastName}
          </>
        )
      ) : cell.column.id === 'userid' ? (
        <>{cell.value.toLowerCase()}</>
      ) : cell.column.id === 'createddate' ? (
        <div className="">
          <span className="submitted-by-date">
            {/*{moment(cell.column.value).format('YYYY-MM-DD')} */}
            {formatDate(cell.value)}
          </span>
          {/*cell.row.values.status?.toLowerCase() === 'pending approval' ? (
            <ApproveDenyButtons
              enrollmentOid={cell.row.original.EnrollmentOID}
              worklistOid={cell.row.original.Oid}
              name={`${cell.row.original.FirstName} ${cell.row.original.MiddleName} ${cell.row.original.LastName}`}
            />
          ) : null*/}
        </div>
      ) : cell.column.id === 'status' ? (
        <div>
          {showStatusIcons(cell.value)}
          {console.log('debug_cell.row.original', cell.row.original)}
          {cell.row.values.status?.toLowerCase() === 'pending approval' ? (
            <ApproveDenyButtons
              enrollmentOid={cell.row.original.EnrollmentOID}
              worklistOid={cell.row.original.Oid}
              name={`${cell.row.original.firstName} ${
                cell.row.original.MiddleName || ''
              } ${cell.row.original.LastName}`}
              isAffiliationRequest={selectedTabLocal === 'affiliation'}
            />
          ) : null}
        </div>
      ) : (
        cell.render('Cell')
      )}
    </td>
  );
};

const EnrollmentTable = ({
  columns,
  data,
  pageSizeCount,
  dataFetching,
  //labelProp = 'My Claims',
  //customSortingHandler,
  sortByColumn,
  //serverSideSorting,
  selectedTabLocal,
  sortingParams,
  serverSideSorting,
}) => {
  const { sortBy: sortedBy, direction: sortedDirection } = sortingParams;
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        hiddenColumns:
          selectedTabLocal === 'affiliation' ? ['LastName', 'Oid'] : [],
        sortBy: sortedBy
          ? [{ id: sortedBy, desc: sortedDirection === 'desc' }]
          : [{ id: 'createddate', desc: true }],
      },
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
  );

  console.log(headerGroups);

  useEffect(() => {
    //customSortingHandler(sortBy[0]?.id, sortBy[0]?.desc, sortBy);
    //serverSideSorting(sortBy); //implement server side sorting
    const sortingFilter = columns?.filter(
      (item) => item?.accessor === sortBy[0]?.id,
    );

    serverSideSorting(
      sortingFilter[0]?.sortingid,
      sortBy[0]?.desc === true ? 'desc' : 'asc',
      sortBy,
    );
  }, [sortBy]);

  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);

  //Render the UI for your table
  return (
    <div>
      <table className="table padding-mobile-0" {...getTableProps()}>
        {data?.length > 0 && !dataFetching && (
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(
                      selectedTabLocal === 'affiliation' &&
                        index !== 1 &&
                        index !== 3 &&
                        index !== 5
                        ? column.getSortByToggleProps({ title: undefined })
                        : selectedTabLocal !== 'affiliation' &&
                            column.getSortByToggleProps({ title: undefined }),
                    )}
                    style={{
                      width: column.width,
                      maxWidth: column.maxWidth,
                      minWidth: column.minWidth,
                    }}
                    className={`${
                      //column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                      sortedBy === column.sortingid
                        ? 'coloumnIsSorted'
                        : 'coloumnNotSorted'
                    } text-left `}
                  >
                    <b>{column.render('Header')}</b>
                    {
                      /*headerGroup.headers?.length - 1 !== index ? */
                      selectedTabLocal === 'affiliation' &&
                      index !== 1 &&
                      index !== 3 &&
                      index !== 5 ? (
                        <span
                          className={`${
                            /*column.isSorted
                              ? column.isSortedDesc
                                ? 'arrowDown'
                                : 'arrowUp'
                              : 'arrowNormal'*/
                            sortedBy === column.sortingid
                              ? sortedDirection === 'asc'
                                ? 'arrowUp'
                                : 'arrowDown'
                              : 'arrowNormal'
                          }`}
                        ></span>
                      ) : selectedTabLocal !== 'affiliation' ? (
                        <span
                          className={`${
                            /*column.isSorted
                              ? column.isSortedDesc
                                ? 'arrowDown'
                                : 'arrowUp'
                              : 'arrowNormal'*/
                            sortedBy === column.sortingid
                              ? sortedDirection === 'asc'
                                ? 'arrowUp'
                                : 'arrowDown'
                              : 'arrowNormal'
                          }`}
                        ></span>
                      ) : null
                    }
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        )}

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className="enrollment-request-table-data-row"
              >
                {row.cells.map((cell, index) => {
                  //console.log('cell >>>>>>>', cell);
                  return (
                    <TableDataCell
                      cell={cell}
                      selectedTabLocal={selectedTabLocal}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default EnrollmentTable;
